import React from 'react';
import {Helmet} from "react-helmet";
import Layout from '../components/Layout';
import AudiForm from '../components/AudiForm';
import Disclaimer from '../components/Disclaimer';
import ReturnToButton from '../components/ReturnToButton';
import queryString from 'query-string';
import MakeModule from '../components/MakeModule';
import { gtmPageview } from '../functions/gtm';
import {
    UI_AUDI_MIN,
    PATH_ADE_BROCHURE,
    PATH_THANKS,
    FIELD_TEXT,
} from '../constants';

const fields = [
    {
        node: <p className="aui-headline-5">Your details</p>
    },
    [
        {
            field: FIELD_TEXT,
            name: "firstName",
            label: "First name",
            colClass: "col-12 col-tiny"
        },
        {
            field: FIELD_TEXT,
            name: "lastName",
            label: "Last name",
            colClass: "col-12 col-tiny"
        }
    ],
    {
        field: FIELD_TEXT,
        name: "emailAddress",
        label: "Email"
    },
    {
        field: FIELD_TEXT,
        name: "postCode",
        label: "Postcode",
        colClass: "col-12 col-small-6"
    },
    {
        module: MakeModule,
        title: "What are you currently driving?"
    }
];

class ADERequestBrochure extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            submitted: false,
            submittedData: {}
        }
    }

    componentDidMount() {
        gtmPageview(PATH_ADE_BROCHURE);
    }

    onSubmit = (values) => {
        this.setState({submitted: true, submittedData: values});
        this.props.history.push(`${PATH_ADE_BROCHURE}${PATH_THANKS}`);
        gtmPageview(`${PATH_ADE_BROCHURE}${PATH_THANKS}`);
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const {submitted, submittedData} = this.state;

        return (
            <Layout ui={query.ui || UI_AUDI_MIN} theme={query.theme} embedded={query.embedded} wide>
                <Helmet>
                    <title>Request a brochure for Audi Driving Experience | Audi Australia</title>
                </Helmet>

                <main className="audi-forms__page">

                    {submitted && <div className="py-5">
                        <h1 className="aui-headline-3 mb-4 pt-3 pt-medium-5">Thanks for your interest in Audi driving experience.</h1>
                        <p className="mb-5">We’ll be sure to send you updates.</p>
                        <ReturnToButton query={query} theme={query.theme} />
                    </div>}

                    {!submitted && <div>
                        <h1 className="aui-headline-3 mb-4 pt-3 pt-medium-5">Request a brochure</h1>
                        <AudiForm formName="requestExperienceBrochure"
                            fields={fields}
                            hiddenFields={{optOut: false}}
                            onSubmitSuccess={this.onSubmit}
                            style={{maxWidth: "840px"}}
                            theme={query.theme}
                        />
                        <Disclaimer theme={query.theme} />
                    </div>}

                </main>
            </Layout>
        );
    }

}

export default ADERequestBrochure;
